import Catalog from '@/js/catalog/catalog.js';
import Certificate from '@/js/catalog/certificate.js';
import naCertificate from '@/js/catalog/unauthorized-certificate.js';
import Loyalty from '@/js/loyalty.js';
import { initRecentlyViewed } from '@/js/sections/recently-viewed';
import { initXpProductsFilter } from '@/js/catalog/xp-products-filter.js';

document.addEventListener("DOMContentLoaded", () => {
	console.log('catalog bundle loaded');

	new Catalog();

	if(window.globalCatalogConf){
		new Certificate();
		new Loyalty();
	} else {
		new naCertificate();
	}

	initXpProductsFilter();
	initRecentlyViewed();
});
